import React, { useState } from "react";
import { NavigationLinks, Section } from "../../../../components";
import { Banner, TiposDeSeguroSorteiosCards } from "../../sections";
import { ReactComponent as ImageNavigationLinks } from "../../../../assets/images/habitacional/ilustracao-casa-habitacional.svg";

const ResultadoSorteiosPage = () => {
  const [description, setDescription] = useState(
    "Escolha o produto e confira se é o seu dia de sorte!"
  );
  return (
    <>
      <Banner
        sectionName="Banner da página de resultado dos sorteios"
        descricao={description}
      />
      <Section
        as={TiposDeSeguroSorteiosCards}
        sectionName="Tipos de seguros dos resultados dos sorteios"
        onProductSelected={setDescription}
      />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        image={<ImageNavigationLinks />}
      />
    </>
  );
};

ResultadoSorteiosPage.propTypes = {};

export default ResultadoSorteiosPage;
